import { MaturityEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const getStages = async (): Promise<any> =>
  APIManager.sendGet(MaturityEnds.STAGES, true, {}, {}, axios);

const getChecklist = async (): Promise<any> =>
  APIManager.sendGet(MaturityEnds.CHECK_LIST, true, {}, {}, axios);

const updateChecklist = async (data: any): Promise<any> =>
  APIManager.sendPost(MaturityEnds.UPDATE_CHECKLIST, data, true, {}, {}, axios);

const getChecklistResponse = async (): Promise<any> =>
  APIManager.sendGet(MaturityEnds.GET_CHECKLIST_RESPONSE, true, {}, {}, axios);

const getSummary = async (): Promise<any> =>
  APIManager.sendGet(MaturityEnds.SUMMARY, true, {}, {}, axios);

export const AIMaturityService = {
  getStages,
  getChecklist,
  updateChecklist,
  getChecklistResponse,
  getSummary,
};
